var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/view/footer/smileytip/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-smiley-tip\">\n\t<div class=\"smiley-wrap\">\n\t\t<img src=\"";
output += runtime.suppressValue((lineno = 2, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "pic")),"replace"), "pic[\"replace\"]", context, [".png","@2x.gif"])), env.opts.autoescape);
output += "\" alt=\"\">\n\t</div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/view/footer/smileytip/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/view/footer/smileytip/tpl.html
// module id = 183
// module chunks = 0 1